module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/incometax-parameter/incometax-parameter.component.css
// module id = ./src/app/hrms/payroll/incometax-parameter/incometax-parameter.component.css
// module chunks = main